module.exports = __webpack_public_path__ + "images/unityLogo-35301897cadfe479a17e7b4059621df3.png";